import React from "react";
import Banner from "./Banner/Banner";
import {
  toolkitData,
  BooksData,
  announcementNewsData,
  mediakitData,
} from "./ResourcesEngagementData";

import styles from "./ResourcesEngagement.module.css";
import Testimonials from "../../sections/Testimonials/Testimonials";

const ResourcesEngagement = () => {
  return (
    <main className={styles.resourceEngagementPage}>
      <Banner />
      <section className={styles.imparcPartners}>
         <div className={styles.container}>
        <h3>
          Toolkits <span>& Reports</span>
        </h3>
        <h5>
          Event outcomes, best practices, and comprehensive guides for research
          excellence
        </h5>
        <div className={styles.cards}>
          {toolkitData.map((item) => (
            <div key={item.id} className={styles.card}>
              <div className={`${item.imageClass} ${styles.image}`}>
                <img src={item.img} alt={item.alt} />
              </div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
              <div className={styles.tagOuter}>
                {item.tags.map((tag, idx) => (
                  <span key={idx} className={styles.tag}>
                    {tag}
                  </span>
                ))}
                <span className={styles.calendar}>&nbsp;</span>
              </div>
              <p className={styles.download}>{item.download}</p>
              {item.time && <p className={styles.time}>{item.time}</p>}
              {item.rating && <p className={styles.rating}>{item.rating}</p>}
              <button className={styles.btn}>{item.buttonText}</button>
            </div>
          ))}
        </div>
        </div>
      </section>
      <section className={`${styles.imparcPartners} ${styles.ispnBooks}`}>
        <div className={styles.container}>
          <h3>
            ISBN Books &{" "}
            <span className={styles.highlight}>Edited Volumes</span>
          </h3>
          <h5>
            Comprehensive scholarly books and edited collections advancing
            research frontiers
          </h5>

          <div className={styles.cards}>
            {BooksData.map((card) => (
              <div key={card.id} className={styles.card}>
                <div className={styles.tagOuter}>
                  <span className={styles.tag}>{card.tag}</span>
                  <span className={styles.calendar}>&nbsp;</span>
                </div>
                <h4>{card.title}</h4>
                <p>{card.description}</p>
                <p className={styles.pages}>{card.pages}</p>
                <p className={styles.scope}>{card.scope}</p>
                <p className={styles.awards}>{card.awards}</p>
                <button className={styles.btn}>Submit Chapter</button>
                <button className={styles.btnOrange}>Guidelines</button>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={`${styles.imparcPartners}  ${styles.announcements}`}>
        <div className={styles.container}>
          <h3>
            Announcements
            <span className={styles.highlight}>& News</span>
          </h3>
          <h5>
            Latest updates, achievements, and important announcements from
            IMPARC
          </h5>

          <div className={styles.cards}>
            {announcementNewsData.map((card) => (
              <div key={card.id} className={styles.card}>
                <div className={styles.right}>
                  <div className={styles.tagOuter}>
                    <span className={styles.tag}>{card.tag}</span>
                    <span className={styles.calendar}>&nbsp;</span>
                  </div>
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                  <button className={styles.btn}>Read More </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Testimonials />
      <section className={`${styles.imparcPartners}  ${styles.mediakit}`}>
        <div className={styles.container}>
        <h3>
          Media Kit <span> & Downloads</span>
        </h3>
        <h5>
          Official IMPARC brand assets, logos, brochures, and presentation
          materials
        </h5>
        <div className={styles.cards}>
          {mediakitData.map((item) => (
            <div key={item.id} className={styles.card}>
              <div className={`${styles.image}`}>
                <img src={item.img} alt={item.alt} />
              </div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
              <div className={styles.tagOuter}>
                {item.tags.map((tag, idx) => (
                  <span key={idx} className={styles.tag}>
                    {tag}
                  </span>
                ))}
              </div>
              <button className={styles.btn}>Download</button>
            </div>
          ))}
        </div>
        </div>
      </section>
    </main>
  );
};

export default ResourcesEngagement;
